import { useLanguage } from "../../../i18n/LanguageContext";

export default function WorkedExampleBlock({ block }) {
  const { language } = useLanguage();

  const c = block.content || {};
  const translated = block.translated_content || {};

  const steps = c.steps || [];
  const translatedSteps = translated.steps || [];

  const getMainTranslation = () => {
    if (language === "zh") {
      return c.chinese || null;
    }

    if (language === "es" || language === "ru") {
      return translated.text || null;
    }

    return null;
  };

  const getStepTranslation = (step, index) => {
    if (language === "zh") {
      return step.chinese || null;
    }

    if (language === "es" || language === "ru") {
      return translatedSteps[index] || null;
    }

    return null;
  };

  const mainTranslation = getMainTranslation();

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          fontWeight: "700",
          marginBottom: "10px",
        }}
      >
        Worked Example
      </div>

      {/* Canonical English */}
      {c.english && (
        <div style={{ lineHeight: "1.65" }}>
          {c.english}
        </div>
      )}

      {/* Selected-language learning aid */}
      {mainTranslation && (
        <div
          style={{
            marginTop: "7px",
            color: "#6b7280",
            lineHeight: "1.65",
          }}
        >
          {mainTranslation}
        </div>
      )}

      {steps.length > 0 && (
        <div
          style={{
            display: "grid",
            gap: "10px",
            marginTop: "16px",
          }}
        >
          {steps.map((step, index) => {
            const stepTranslation =
              getStepTranslation(step, index);

            return (
              <div
                key={index}
                style={{
                  padding: "10px 12px",
                  backgroundColor: "#f8fafc",
                  borderRadius: "10px",
                }}
              >
                <div style={{ fontWeight: "600" }}>
                  Step {index + 1}
                </div>

                {/* Canonical English */}
                {step.english && (
                  <div style={{ marginTop: "4px" }}>
                    {step.english}
                  </div>
                )}

                {/* Selected-language learning aid */}
                {stepTranslation && (
                  <div
                    style={{
                      marginTop: "4px",
                      color: "#6b7280",
                      lineHeight: "1.6",
                    }}
                  >
                    {stepTranslation}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}